import { useCredentialRequirementConfiguration } from "@src/appV2/redesign/Documents/useCredentialRequirementConfiguration";

import { transformPlacementData, useGetPlacement } from "../../api/useGetPlacement";

const POLLING_INTERVAL_MS = 5000; // Poll every 5 seconds

interface UsePollingWorkerRequirementsParams {
  placementId: string;
  workerId: string;
  enabled: boolean;
}

interface UsePollingWorkerRequirementsResult {
  hasMissingOrPendingDocuments: boolean;
  isLoading: boolean;
}

export function usePollingWorkerRequirements(
  params: UsePollingWorkerRequirementsParams
): UsePollingWorkerRequirementsResult {
  const { placementId, workerId, enabled } = params;

  const { data: placement, isLoading } = useGetPlacement(
    { placementId, workerId },
    {
      enabled,
      refetchInterval: enabled ? POLLING_INTERVAL_MS : false,
      refetchIntervalInBackground: true,
    }
  );

  const credentialRequirementConfiguration = useCredentialRequirementConfiguration();

  const placementDetails = placement
    ? transformPlacementData(placement, credentialRequirementConfiguration)
    : undefined;

  const hasMissingOrPendingDocuments =
    placementDetails?.workerRequirements?.some((requirement) => !requirement.attributes.isValid) ??
    true;

  return {
    hasMissingOrPendingDocuments,
    isLoading,
  };
}
